import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const FleetMap = () => {
  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [mapView, setMapView] = useState('traffic');
  const [showGeofences, setShowGeofences] = useState(true);

  const vehicles = [
    {
      id: 'FL-001',
      driver: 'Michael Johnson',
      status: 'active',
      location: 'Downtown Detroit',
      speed: 45,
      fuel: 78,
      eta: '14:30',
      route: 'Route A-1',
      lat: 42.3314,
      lng: -83.0458
    },
    {
      id: 'FL-002',
      driver: 'Sarah Williams',
      status: 'idle',
      location: 'Warehouse District',
      speed: 0,
      fuel: 92,
      eta: '15:15',
      route: 'Route B-2',
      lat: 42.3284,
      lng: -83.0398
    },
    {
      id: 'FL-003',
      driver: 'David Chen',
      status: 'maintenance',
      location: 'Service Center',
      speed: 0,
      fuel: 45,
      eta: 'N/A',
      route: 'Off Route',
      lat: 42.3354,
      lng: -83.0428
    },
    {
      id: 'FL-004',
      driver: 'Lisa Rodriguez',
      status: 'active',
      location: 'Highway I-75',
      speed: 65,
      fuel: 67,
      eta: '16:45',
      route: 'Route C-3',
      lat: 42.3244,
      lng: -83.0518
    }
  ];

  const geofences = [
    { id: 1, name: 'Warehouse Zone', type: 'safe', active: true },
    { id: 2, name: 'Customer Area', type: 'delivery', active: true },
    { id: 3, name: 'Restricted Zone', type: 'warning', active: false }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'bg-success';
      case 'idle': return 'bg-warning';
      case 'maintenance': return 'bg-error';
      default: return 'bg-muted-foreground';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active': return 'Truck';
      case 'idle': return 'Clock';
      case 'maintenance': return 'Wrench';
      default: return 'MapPin';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      {/* Map Controls */}
      <div className="flex items-center justify-between p-4 border-b border-border">
        <h3 className="text-lg font-semibold text-foreground">Live Fleet Tracking</h3>
        
        <div className="flex items-center space-x-2">
          <div className="flex items-center space-x-1 bg-muted rounded-lg p-1">
            <button
              onClick={() => setMapView('traffic')}
              className={`px-3 py-1 text-xs font-medium rounded-md nav-transition ${
                mapView === 'traffic' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Traffic
            </button>
            <button
              onClick={() => setMapView('satellite')}
              className={`px-3 py-1 text-xs font-medium rounded-md nav-transition ${
                mapView === 'satellite' ?'bg-primary text-primary-foreground' :'text-muted-foreground hover:text-foreground'
              }`}
            >
              Satellite
            </button>
          </div>
          
          <button
            onClick={() => setShowGeofences(!showGeofences)}
            className={`flex items-center space-x-1 px-3 py-1 text-xs font-medium rounded-lg nav-transition ${
              showGeofences 
                ? 'bg-accent text-accent-foreground' 
                : 'bg-muted text-muted-foreground hover:text-foreground'
            }`}
          >
            <Icon name="Shield" size={14} />
            <span>Geofences</span>
          </button>
        </div>
      </div>
      {/* Map Container */}
      <div className="relative h-96 bg-muted">
        {/* Google Maps Iframe */}
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title="Fleet Tracking Map"
          referrerPolicy="no-referrer-when-downgrade"
          src="https://www.google.com/maps?q=42.3314,-83.0458&z=12&output=embed"
          className="w-full h-full"
        />

        {/* Vehicle Markers Overlay */}
        <div className="absolute inset-0 pointer-events-none">
          {vehicles?.map((vehicle, index) => (
            <div
              key={vehicle?.id}
              className="absolute pointer-events-auto cursor-pointer"
              style={{
                left: `${20 + index * 20}%`,
                top: `${30 + index * 15}%`,
                transform: 'translate(-50%, -50%)'
              }}
              onClick={() => setSelectedVehicle(selectedVehicle?.id === vehicle?.id ? null : vehicle)}
            >
              <div className={`flex items-center justify-center w-8 h-8 rounded-full ${getStatusColor(vehicle?.status)} shadow-lg`}>
                <Icon name={getStatusIcon(vehicle?.status)} size={16} color="white" />
              </div>
              
              {/* Vehicle Info Popup */}
              {selectedVehicle?.id === vehicle?.id && (
                <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-64 bg-popover border border-border rounded-lg shadow-lg p-3 animate-slide-down">
                  <div className="flex items-center justify-between mb-2">
                    <span className="font-semibold text-foreground">{vehicle?.id}</span>
                    <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusColor(vehicle?.status)} text-white`}>
                      {vehicle?.status}
                    </span>
                  </div>
                  
                  <div className="space-y-1 text-sm">
                    <div className="flex items-center space-x-2">
                      <Icon name="User" size={14} />
                      <span className="text-muted-foreground">{vehicle?.driver}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="MapPin" size={14} />
                      <span className="text-muted-foreground">{vehicle?.location}</span>
                    </div>
                    <div className="flex items-center justify-between">
                      <div className="flex items-center space-x-1">
                        <Icon name="Gauge" size={14} />
                        <span className="text-muted-foreground">{vehicle?.speed} mph</span>
                      </div>
                      <div className="flex items-center space-x-1">
                        <Icon name="Fuel" size={14} />
                        <span className="text-muted-foreground">{vehicle?.fuel}%</span>
                      </div>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="Clock" size={14} />
                      <span className="text-muted-foreground">ETA: {vehicle?.eta}</span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Map Legend */}
        <div className="absolute bottom-4 left-4 bg-popover border border-border rounded-lg p-3 shadow-lg">
          <h4 className="text-xs font-semibold text-foreground mb-2">Vehicle Status</h4>
          <div className="space-y-1">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-success rounded-full"></div>
              <span className="text-xs text-muted-foreground">Active ({vehicles?.filter(v => v?.status === 'active')?.length})</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-warning rounded-full"></div>
              <span className="text-xs text-muted-foreground">Idle ({vehicles?.filter(v => v?.status === 'idle')?.length})</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-error rounded-full"></div>
              <span className="text-xs text-muted-foreground">Maintenance ({vehicles?.filter(v => v?.status === 'maintenance')?.length})</span>
            </div>
          </div>
        </div>
      </div>
      {/* Quick Actions */}
      <div className="flex items-center justify-between p-4 bg-muted border-t border-border">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <div className="status-indicator status-online"></div>
            <span className="text-sm text-muted-foreground">Live tracking active</span>
          </div>
          <span className="text-xs text-muted-foreground">Last update: 30s ago</span>
        </div>
        
        <div className="flex items-center space-x-2">
          <button className="flex items-center space-x-1 px-3 py-1 text-xs font-medium text-muted-foreground hover:text-foreground bg-background border border-border rounded-lg nav-transition">
            <Icon name="RefreshCw" size={14} />
            <span>Refresh</span>
          </button>
          <button className="flex items-center space-x-1 px-3 py-1 text-xs font-medium text-muted-foreground hover:text-foreground bg-background border border-border rounded-lg nav-transition">
            <Icon name="Maximize2" size={14} />
            <span>Fullscreen</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default FleetMap;